import client from '../config/AxiosConfig';

export const GetConfigs = async () => client.get('/configs');

export const GetConfig = async (id) => client.get(`/configs/${id}`);

export const UpdateConfigType = async (id, data) =>
  client.put(`/configs/${id}`, data);
